module.exports = __webpack_public_path__ + "img/moldova.16e3445a.svg";